module.exports = __webpack_public_path__ + "static/bunkaryoku-be66e657451a11883fa7cb9b962723c5.jpg";